import React, { useEffect, useRef, useState } from "react"

import { useWindowSize } from "components/hooks/use-window-size"

type ScrollableContentProps = {
  children?: React.ReactNode
  className?: string
}
export function ExpandedBox({ children, className = "" }: ScrollableContentProps) {
  const [fittedHeight, setFittedHeight] = useState(0)
  const containerRef = useRef<HTMLDivElement>(null)
  const size = useWindowSize()

  useEffect(() => {
    const parentContainer = containerRef?.current?.parentElement

    if (parentContainer) {
      const style = window.getComputedStyle(parentContainer)
      const isFlexColumn = style.getPropertyValue("flex-direction")

      if (isFlexColumn) {
        setFittedHeight(parentContainer.clientHeight)
        const siblings = [...parentContainer.children].filter(child => child !== containerRef?.current)

        const primaryHeight = siblings.map(sibling => sibling.clientHeight).reduce((prev, current) => prev + current, 0)
        setFittedHeight(parentContainer.clientHeight - primaryHeight)
      } else {
        setFittedHeight(parentContainer.clientHeight)
      }
    }
  }, [size, children])

  return (
    <div style={{ height: fittedHeight }} ref={containerRef} className={className}>
      {children}
    </div>
  )
}
